export default class DialogPassengerCounter {
  static EVENT_UPDATE_COUNT = 'eventUpdateCount';

  constructor(_parent,_defCount = 0,_minCount = 0) {

    this.el = document.createElement('div');

    this.target = document.createElement('dd');

    this.tmpCount = this.count = _defCount;

    const html = `
    <button type="button" aria-label="減らす" class="-btn_minus"></button>
      <span class="-n">${this.count}</span>
     <button type="button" aria-label="増やす" class="-btn_plus"></button>
    `;
    this.target.innerHTML = html;
    _parent.appendChild(this.target);

    this.target.querySelector('.-btn_minus').addEventListener("click",()=>{
      let count = this.count - 1;
      if(count < _minCount) return;
      this.tmpCount = count;
      this.el.dispatchEvent(new CustomEvent(DialogPassengerCounter.EVENT_UPDATE_COUNT));
    });

    this.btnPlus = this.target.querySelector('.-btn_plus');

    this.btnPlus.addEventListener("click",()=>{
      this.tmpCount = this.count + 1;
      this.el.dispatchEvent(new CustomEvent(DialogPassengerCounter.EVENT_UPDATE_COUNT));
    });
  }

  updateCount(){
    this.count = this.tmpCount;
    this.target.querySelector('.-n').innerText = this.count;
  }
}
